<template>
  <div>
    <el-dialog class="dialog-add-choose-collect" title="查看团队预约" :visible.sync="dialogVisible" width="70%"
      @close="onCancel">
      <el-form ref="addForm" :model="addForm" label-width="135px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="机构类型 :">
              <span>{{ addForm.orgType }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构名称 :">
              <span> {{ addForm.orgName }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="负责人姓名 :">
              <span>{{ addForm.headName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="负责人联系方式 :">
              <span> {{ addForm.headPhone }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="负责人证件号码 :">
              <span>{{ addForm.headIdentificationNumber }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参观日期 :">
              <span> {{ addForm.appointDate ? addForm.appointDate.slice(0, 10) : '' }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="参观时段 :">
              <span>{{ addForm.startTime }}-{{ addForm.endTime }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="游客人数 :">
              <span> {{ addForm.peopleNumber }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="团队类型 :">
              <span> {{ addForm.teamType }}</span>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
                        <el-form-item label="游客信息表 :" >
                            <span>{{ addForm.orgType }}</span>
                        </el-form-item>
                    </el-col> -->
          <el-col :span="12">
            <el-form-item label="订单状态 :">
              <span> {{ addForm.orderStatus | filterStatus(orderList) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="渠道 :">
              <span>{{ addForm.platform }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核状态 :">
              <span> {{ addForm.approveStatus | filterStatus(approveStatus) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原因 :">
              <span>{{ addForm.remark }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构统一信息代码 :">
              <span>{{ addForm.orgCreditCode }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="机构营业执照 :">
              <el-image :src="addForm.orgPicture"
                :preview-src-list="addForm.orgPicture && addForm.orgPicture.split(',')">
              </el-image>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="身份证正面 :">
              <el-image :src="addForm.idcardPicFront"
                :preview-src-list="addForm.idcardPicFront && addForm.idcardPicFront.split(',')">
              </el-image>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="身份证反面 :">
              <el-image :src="addForm.idcardPicBack"
                :preview-src-list="addForm.idcardPicBack && addForm.idcardPicBack.split(',')">
              </el-image>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="介绍信 :">
              <el-image :src="addForm.introduceInfo"
                :preview-src-list="addForm.introduceInfo && addForm.introduceInfo.split(',')">
              </el-image>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
                        <el-form-item label="入馆/取消时间 :">
                            <span> {{ addForm.orgName }}</span>
                        </el-form-item>
                    </el-col> -->

        </el-row>

      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addForm: {},
      orderList: [
        { value: '0', label: '已取消' },
        { value: '1', label: '待参观' },
        { value: '2', label: '已入馆' },
        { value: '3', label: '已过期' },
        { value: '4', label: '待审核' },
        { value: '5', label: '已驳回' }
      ],
      approveStatus: [
        { value: '0', label: '待审批' },
        { value: '1', label: '已通过' },
        { value: '2', label: '已拒绝' }
      ],
      platformList: [
        { value: '1', label: '支付宝' },
        { value: '2', label: '微信' }
      ],

      dialogVisible: false
    }
  },

  filters: {
    filterStatus(status, list) {
      let obj = list.filter((item) => {
        return item.value == status
      })

      if (obj && obj.length > 0) {
        return obj[0].label
      }

      return null
    }
  },

  methods: {
    init(id) {
      this.dialogVisible = true
      this.getDetail(id)
    },

    onCancel() {
      this.addForm = {}
      this.dialogVisible = false
    },
    getDetail(id) {
      this.$api.appointSetting.teamAppointDetail({ id: id }).then((res) => {
        if (res.code == 200) {
          this.addForm = res.result
        } else {
          this.$message.error(res.message || '系统异常')
        }
      })
    }
  },
  mounted() { }
}
</script>

<style lang='scss' scoped>
.el-form-item {
  .el-form-item__content {
    .el-image {
      width: 200px;
    }
  }
}
</style>